// extracted by mini-css-extract-plugin
export default {"button":"choose-button_button__eWaB7","icon":"choose-button_icon__zF8r3","selected":"choose-button_selected__oqZj0"};